import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4199caee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-item" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "desc" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "Current state", -1))
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "desc" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "Loan amount", -1))
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "desc" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "Due date", -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "btns" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "desc" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "Current state", -1))
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "desc" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "Loan amount", -1))
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "btns" }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"star\" data-v-4199caee><span class=\"e f\" data-v-4199caee></span><span class=\"e f\" data-v-4199caee></span><span class=\"e f\" data-v-4199caee></span><span class=\"e f\" data-v-4199caee></span><span class=\"e h\" data-v-4199caee></span><span class=\"s\" data-v-4199caee>4.8</span></div>", 1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Complete documents in 5 minutes", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "icon",
        style: _normalizeStyle({backgroundImage:`url(${_ctx.app.icon})`})
      }, null, 4),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.app.app_name), 1),
      (_ctx.orderState < 3)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openView(_ctx.app)))
          }, "GET A LOAN"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.orderState == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.orderStateText), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.order.loan_val), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.order.repay_end_time), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("a", {
                class: "btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openRepay(_ctx.app)))
              }, "REPAY THE LOAN")
            ])
          ]))
        : (_ctx.orderState != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.orderStateText), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.order.loan_val), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                (_ctx.orderState >= 4)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "btn",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openView(_ctx.app)))
                    }, "NEXT"))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _hoisted_25,
              (_ctx.app.is_old_customer == '0')
                ? (_openBlock(), _createElementBlock("p", _hoisted_26, "Initial Credit: ₱ " + _toDisplayString(_ctx.app.init_amount), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", null, "Max. Available Borrowing: ₱ " + _toDisplayString(_ctx.app.max_amount), 1),
              _hoisted_27
            ]))
    ])
  ]))
}